import React, { useState } from "react";
import Contact from "../Contact/Contact";
import Footer from "../Footer/Footer";
import Landing from "../Landing/Landing";
import Navbar from "../NavBar/Navbar";
import NavbarMenu from "../NavbarMenu/NavbarMenu";
import toparrow from "../../image/newImg/toparrow.png";
import SideBar from "../SideBar/SideBar";
import "./Content.css";
import "./Results.css";
// import { Col, Row } from "react-bootstrap";
// import r10 from "../../image/r10/result-10.jpg";
// import r12 from "../../image/r10/result-12.jpg";
// import r122 from "../../image/r10/result-12-2.jpg";
import { Row, Col, Button } from "react-bootstrap";
import {
  disclosure_data_results_10,
  disclosure_data_results_12,
} from "../../variable";


import board from "../../image/board.jpg";
// import board from "../../image/bright10.jpg";
import board12 from "../../image/board12.jpg";
// import board12 from "../../image/bright12.jpg";

const x12th = require("../../excel/bhimtal12.xlsx");
const x10th = require("../../excel/bhimtal10.xlsx");
const res = require("../../excel/Results of all schools - website upload.xlsx");

function Results(props) {
  const { cover, sidebar_data, side_heading, side_sub_heading } = props;
  const [isScrolled, setIsScrolled] = useState(false);
  const [isShow, steIsShow] = useState(false);
  const handleScroll = (e) => {
    if (e.target.scrollTop > 0 && !isScrolled) {
      setIsScrolled(true);
    }
    if (e.target.scrollTop === 0) {
      setIsScrolled(false);
    }
  };
  const handleClick = () => {
    steIsShow(!isShow);
    console.log(isShow);
  };

  return (
    <div className="content_main" onScroll={handleScroll}>
      <Navbar isScrolled={isScrolled} handleClick={handleClick} />
      <NavbarMenu isShow={isShow} handleClick={handleClick} />
      <Landing video={false} cover={cover} />
      <div className="contentmain_cont">
        <div style={{ width: "min-content" }}>
          <SideBar
            sidebar_data={sidebar_data}
            side_heading={side_heading}
            side_sub_heading={side_sub_heading}
          />
          <Contact />
        </div>
        <div>
          <div className={`f-2 f-500 mb-3`} style={{ color: "#1FDC00ED" }}>
            <img
              className="admissions__image"
              src={toparrow}
              style={{ marginRight: "1rem" }}
              alt=""
            />{" "}
            Results
          </div>

      <div className="my-4">
          <div
            className=""
            style={{ fontSize: "20px", fontWeight: "700" }}
          >
            RESULT CLASS: X
          </div>
          <div
            className="container"
            style={{ display: "flex", flexDirection: "column" }}
          >
            {disclosure_data_results_10.map((item, index) => (
              <Row className="mandatory_list">
                <Col className="mandatory_col" lg={1}>
                  {item.title}
                </Col>
                <Col className="mandatory_col" lg={2}>
                  {item.extra_title}
                </Col>
                <Col className="mandatory_col" lg={3}>
                  {item.name}
                </Col>
                <Col className="mandatory_col" lg={3}>
                  {item.description}
                </Col>
                <Col className="mandatory_col_last" lg={3}>
                  {item.extra_description}
                </Col>
              </Row>
            ))}
          </div>
         </div>

         <div
          className=""
          style={{ fontSize: "20px", fontWeight: "700" }}
        >
          RESULT CLASS: XII
        </div>
        <div
          className="container"
          style={{ display: "flex", flexDirection: "column" }}
        >
          {disclosure_data_results_12.map((item, index) => (
            <Row className="mandatory_list">
              <Col className="mandatory_col" lg={1}>
                {item.title}
              </Col>
              <Col className="mandatory_col" lg={2}>
                {item.extra_title}
              </Col>
              <Col className="mandatory_col" lg={3}>
                {item.name}
              </Col>
              <Col className="mandatory_col" lg={3}>
                {item.description}
              </Col>
              <Col className="mandatory_col_last" lg={3}>
                {item.extra_description}
              </Col>
            </Row>
          ))}
        </div>
         
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default Results;
